import { Button, Flex, Modal, Typography } from '@iheartjane/reefer';

import { ClientOnly } from '@jane/bloom/components/clientOnly';
import { BRAND_SPECIAL_SHORTFALL_MESSAGE } from '@jane/bloom/utils/cart/brandSpecialShortfall';

export const BrandSpecialShortfallModal = ({
  onRequestClose,
  open,
}: {
  onRequestClose: () => void;
  open: boolean;
}) => (
  <ClientOnly>
    {() => (
      <Modal variant="dialogue" onRequestClose={onRequestClose} open={open}>
        <Modal.Content>
          <Flex width="300px" flexDirection="column" alignItems="center">
            <Typography variant="h1-semibold" mb={16} color="text-main">
              Bag updated
            </Typography>

            <Typography mb={32} color="text-main" textAlign="center">
              {BRAND_SPECIAL_SHORTFALL_MESSAGE}
            </Typography>
          </Flex>

          <Button full variant="primary" label="OK" onClick={onRequestClose} />
        </Modal.Content>
      </Modal>
    )}
  </ClientOnly>
);
